import axios from 'axios'
import {envVariables} from '../utils/envVariables/envVariables'

const PASSWORD_RESET_BASE_URL = `${envVariables.baseUrl}/user/password-reset`

export const requestPasswordReset = async (email) => {
	return axios.post(
		`${PASSWORD_RESET_BASE_URL}/request`,
		{email},
		{
			headers: {
				'Content-Type': 'application/json',
			},
		}
	)
}

export const confirmPasswordReset = async ({token, password}) => {
	return axios.post(
		`${PASSWORD_RESET_BASE_URL}/confirm`,
		{token, password},
		{
			headers: {
				'Content-Type': 'application/json',
			},
		}
	)
}
